<article class="youth-info-center-card">
  <img
    class="youth-info-center-card__logo"
    [class.youth-info-center-card__logo--mobile]="isMobile$ | async"
    [src]="logoSrc | imaginarySrc: 1:90"
    [srcset]="logoSrc | imaginarySrc: 4:90"
    alt=""
  />
  <div class="youth-info-center-card__structure">
    <header class="youth-info-center-card__structure__header">
      <h3 class="youth-info-center-card__structure__header__title">
        <span
          [class.line-break]="isMobile$ | async"
          [class.youth-info-center-card__structure__header__title--dash]="(isMobile$ | async) === false"
          >{{ youthInfoCenterTypeLabel }}</span
        >
        {{ youthInfoCenterLabel }}
      </h3>
      <app-youth-info-center-tooltip
        class="youth-info-center-card__structure__header__tooltip"
        *ngIf="youthInfoCenter.type !== YouthInfoCenterTypeEnum.CIJ"
      ></app-youth-info-center-tooltip>
    </header>
    <app-youth-info-center-card-address
      class="youth-info-center-card__structure__address"
      [youthInfoCenterStreet]="youthInfoCenterStreet"
      [youthInfoCenterCity]="youthInfoCenterCity"
      [youthInfoCenterZipCode]="youthInfoCenterZipCode"
      [youthInfoCenterMapLink]="youthInfoCenterMapLink"
      [linkAriaLabel]="linkAriaLabel"
    ></app-youth-info-center-card-address>
  </div>

  <button
    type="button"
    class="btn-clean youth-info-center-card__detail-button"
    [class.youth-info-center-card__detail-button--open]="panelOpenState$ | async"
    (click)="toggleExpansionPanel()"
  >
    Détails
    <mat-icon
      class="youth-info-center-card__detail-button__icon"
      [class.youth-info-center-card__detail-button__icon--open]="panelOpenState$ | async"
      svgIcon="chevron_down"
      role="presentation"
    ></mat-icon>
  </button>

  <button
    type="button"
    class="btn youth-info-center-card__contact-button"
    [attr.aria-label]="'Contacter l\'organisme ' + youthInfoCenterLabel"
    [id]="elm_id"
    (click)="openModal()"
  >
    {{ contactLabel }}
  </button>

  <mat-expansion-panel
    hideToggle
    class="youth-info-center-card__expansion-panel"
    [class.youth-info-center-card__expansion-panel--open]="panelOpenState$ | async"
    [expanded]="panelOpenState$ | async"
  >
    <ng-container *ngTemplateOutlet="details"></ng-container>
  </mat-expansion-panel>
</article>

<ng-template #details>
  <app-youth-info-center-card-details
    [phone]="youthInfoCenter?.phoneNumber"
    [email]="youthInfoCenter?.email"
    [url]="youthInfoCenter?.url"
    [name]="youthInfoCenterLabel"
    [schedules]="youthInfoCenter.schedules"
  ></app-youth-info-center-card-details>
</ng-template>
